module.exports = __webpack_public_path__ + "img/Group-1.a3e2e3e9.jpg";